/* eslint-disable import/prefer-default-export */
import updateUserApi from './updateUser';

const api = {
  updateUserApi
};

export default api;
